module.exports = __webpack_public_path__ + "static/media/screenblue.31945640.png";